module.exports = __webpack_public_path__ + "static/media/ipnos-scenario-2.e13f1c5c.png";